import React from 'react';
import PropTypes from 'prop-types';

const TextArea = ({
  name,
  placeholder,
  rows,
  value,
  label,
  onChange,
  error,
  extraClass,
  autoFocus,
  inputClass,
  style,
}) => {
  let wrapperClass = 'form-group';
  if (extraClass) {
    wrapperClass += ' ' + extraClass;
  }

  return (
    <div className={wrapperClass}>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="field">
        <textarea
          rows={rows}
          type="text"
          name={name}
          className={'form-control ' + inputClass}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={style}
          autoFocus={autoFocus}
        />
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    </div>
  );
};

TextArea.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  extraClass: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  rows: PropTypes.number,
  autoFocus: PropTypes.bool,
  inputClass: PropTypes.string,
  style: PropTypes.object,
};

export default TextArea;
